module.exports = __webpack_public_path__ + "img/fr8.973289fd.png";